/* global axios */

import ApiClient from './ApiClient';

class KanboardAPI extends ApiClient {
  constructor() {
    super('kanboard', { accountScoped: true });
  }

  getAutoLoginUrl() {
    return axios.get(`${this.url}/auto_login_url`);
  }
}

export default new KanboardAPI();
